import * as XLSX from 'xlsx-js-style'
import { Button } from "antd"
import { FaFileExcel } from "react-icons/fa";
import { useState } from "react";

const ExportExcel = ({ data, fileName, title }) => {
    const [loading, setLoading] = useState(false);

    const handleExport = async () => {
        setLoading(true);

        let resolvedData;
        try {
            resolvedData = typeof data === 'function' ? await data() : data;
        } finally {
            setLoading(false);
        }

        const dataArray = Array.isArray(resolvedData) ? resolvedData : [resolvedData];
        if (dataArray.length === 0) return;

        // Crear hoja de Excel
        const ws = XLSX.utils.json_to_sheet(dataArray.map(row => {
            return Object.keys(row).reduce((acc, key) => {
                const newKey = key.replace(/^(\d+_)/, '');
                if (row[key] === true) {
                    acc[newKey] = 'Sí';
                } else if (row[key] === false) {
                    acc[newKey] = 'No';
                } else {
                    acc[newKey] = row[key];
                }
                return acc;
            }, {});
        }));

        const range = XLSX.utils.decode_range(ws['!ref']);

        // Estilos para el encabezado
        const headerStyle = {
            fill: { fgColor: { rgb: "284473" } },
            font: { color: { rgb: "FFFFFF" }, sz: 12, bold: true },
            alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
            border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        };

        // Estilos para las celdas
        const cellStyle = {
            fill: { fgColor: { rgb: "FFFFFF" } },
            font: { color: { rgb: "000000" }, sz: 12 },
            alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
            numFmt: '@',
            border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        };

        // Aplicar estilos a las celdas
        for (let row = range.s.r; row <= range.e.r; row++) {
            for (let col = range.s.c; col <= range.e.c; col++) {
                const cell = ws[XLSX.utils.encode_cell({ r: row, c: col })];
                if (cell) {
                    cell.s = (row === range.s.r) ? headerStyle : cellStyle;
                }
            }
        }

        // Ajustar el ancho de las columnas
        ws['!cols'] = Array.from({ length: range.e.c - range.s.c + 1 }).map(() => ({ width: 20 }));

        // Crear y descargar el archivo Excel
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Hoja 1");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    return (
        <Button
            onClick={handleExport}
            loading={loading}
            className="mr-2 flex items-center gap-2 rounded-lg border-none bg-green-500 px-5 py-2 text-sm font-semibold text-white shadow-sm transition duration-200 hover:bg-green-600 active:bg-green-700 disabled:cursor-wait disabled:opacity-80"
        >
            <FaFileExcel />
            {title}
        </Button>
    );
};

export default ExportExcel;
